import { Suspense } from "react";
import Skeleton from "legacy/components/utils/Skeleton";
import { VALIDATION_TYPES } from "legacy/constants/WidgetValidation";
import { BASE_WIDGET_VALIDATION } from "legacy/constants/WidgetValidation";
import BaseWidget from "../BaseWidget";
import PDFViewerComponent from "./PDFViewerComponent";
import PDFViewerPropertyCategories from "./PDFViewerPropertyCategories";
import type { WidgetPropsRuntime, WidgetState } from "../BaseWidget";
import type { PropertyPaneConfig } from "legacy/constants/PropertyControlConstants";
import type { WidgetType } from "legacy/constants/WidgetConstants";
import type { WidgetPropertyValidationType } from "legacy/constants/WidgetValidation";

class PDFViewerWidget extends BaseWidget<PDFViewerWidgetProps, WidgetState> {
  static getNewPropertyPaneConfig():
    | PropertyPaneConfig<PDFViewerWidgetProps>[]
    | undefined {
    return PDFViewerPropertyCategories;
  }

  static getPropertyPaneConfig(): PropertyPaneConfig[] {
    throw new Error("Deprecated config should not be called");
  }

  static getPropertyValidationMap(): WidgetPropertyValidationType {
    return {
      ...BASE_WIDGET_VALIDATION,
      fileUrl: VALIDATION_TYPES.URL_OR_BASE64,
    };
  }

  getPageView() {
    return (
      <Suspense fallback={<Skeleton />}>
        <PDFViewerComponent
          widgetId={this.props.widgetId}
          fileUrl={this.props.fileUrl}
          isLoading={this.props.isLoading}
        />
      </Suspense>
    );
  }

  getWidgetType(): WidgetType {
    return "PDF_VIEWER_WIDGET";
  }
}

export interface PDFViewerWidgetProps extends WidgetPropsRuntime {
  fileUrl?: string;
}

export default PDFViewerWidget;
